// timezones generated by /scripts/timezones/index.js

export default [
  {
    name: 'GMT-11 Pacific/Midway ',
    abbrev: 'Pacific/Midway',
  },
  {
    name: 'GMT-11 Pacific/Niue : Alofi',
    abbrev: 'Pacific/Niue',
  },
  {
    name: 'GMT-11 Pacific/Pago_Pago : Pago Pago, Tāfuna, Ta`ū, Taulaga',
    abbrev: 'Pacific/Pago_Pago',
  },
  {
    name: 'GMT-10 America/Adak ',
    abbrev: 'America/Adak',
  },
  {
    name: 'GMT-10 Pacific/Honolulu : Honolulu, East Honolulu, Pearl City, Hilo, Kailua',
    abbrev: 'Pacific/Honolulu',
  },
  {
    name: 'GMT-10 Pacific/Rarotonga : Avarua',
    abbrev: 'Pacific/Rarotonga',
  },
  {
    name: 'GMT-10 Pacific/Tahiti : Faaa, Papeete, Punaauia, Pirae, Mahina',
    abbrev: 'Pacific/Tahiti',
  },
  {
    name: 'GMT-9:30 Pacific/Marquesas : Taiohae',
    abbrev: 'Pacific/Marquesas',
  },
  {
    name: 'GMT-9 America/Anchorage : Anchorage, Fairbanks, Eagle River, Badger, Knik-Fairview',
    abbrev: 'America/Anchorage',
  },
  {
    name: 'GMT-9 America/Juneau : Juneau',
    abbrev: 'America/Juneau',
  },
  {
    name: 'GMT-9 America/Metlakatla ',
    abbrev: 'America/Metlakatla',
  },
  {
    name: 'GMT-9 America/Nome ',
    abbrev: 'America/Nome',
  },
  {
    name: 'GMT-9 America/Sitka : Sitka, Ketchikan',
    abbrev: 'America/Sitka',
  },
  {
    name: 'GMT-9 America/Yakutat ',
    abbrev: 'America/Yakutat',
  },
  {
    name: 'GMT-9 Pacific/Gambier ',
    abbrev: 'Pacific/Gambier',
  },
  {
    name: 'GMT-8 America/Los_Angeles : Los Angeles, San Diego, San Jose, San Francisco, Seattle',
    abbrev: 'America/Los_Angeles',
  },
  {
    name: 'GMT-8 America/Tijuana : Tijuana, Mexicali, Ensenada, Rosarito, Tecate',
    abbrev: 'America/Tijuana',
  },
  {
    name: 'GMT-8 America/Vancouver : Vancouver, Surrey, Okanagan, Victoria, Burnaby',
    abbrev: 'America/Vancouver',
  },
  {
    name: 'GMT-8 Pacific/Pitcairn : Adamstown',
    abbrev: 'Pacific/Pitcairn',
  },
  {
    name: 'GMT-7 America/Boise : Boise, Meridian, Nampa, Idaho Falls, Pocatello',
    abbrev: 'America/Boise',
  },
  {
    name: 'GMT-7 America/Cambridge_Bay ',
    abbrev: 'America/Cambridge_Bay',
  },
  {
    name:
      'GMT-7 America/Chihuahua : Chihuahua, Ciudad Delicias, Cuauhtémoc, Parral, Nuevo Casas Grandes',
    abbrev: 'America/Chihuahua',
  },
  {
    name: 'GMT-7 America/Creston ',
    abbrev: 'America/Creston',
  },
  {
    name: 'GMT-7 America/Dawson ',
    abbrev: 'America/Dawson',
  },
  {
    name: 'GMT-7 America/Dawson_Creek : Fort St. John, Dawson Creek',
    abbrev: 'America/Dawson_Creek',
  },
  {
    name: 'GMT-7 America/Denver : Denver, El Paso, Albuquerque, Colorado Springs, Aurora',
    abbrev: 'America/Denver',
  },
  {
    name: 'GMT-7 America/Edmonton : Calgary, Edmonton, Fort McMurray, Red Deer, Lethbridge',
    abbrev: 'America/Edmonton',
  },
  {
    name: 'GMT-7 America/Fort_Nelson ',
    abbrev: 'America/Fort_Nelson',
  },
  {
    name:
      'GMT-7 America/Hermosillo : Hermosillo, Ciudad Obregón, Nogales, San Luis Río Colorado, Navojoa',
    abbrev: 'America/Hermosillo',
  },
  {
    name: 'GMT-7 America/Inuvik ',
    abbrev: 'America/Inuvik',
  },
  {
    name: 'GMT-7 America/Mazatlan : Culiacán, Mazatlán, Tepic, Los Mochis, La Paz',
    abbrev: 'America/Mazatlan',
  },
  {
    name: 'GMT-7 America/Ojinaga : Juárez, Manuel Ojinaga, Ojinaga',
    abbrev: 'America/Ojinaga',
  },
  {
    name: 'GMT-7 America/Phoenix : Phoenix, Tucson, Mesa, Chandler, Gilbert',
    abbrev: 'America/Phoenix',
  },
  {
    name: 'GMT-7 America/Whitehorse : Whitehorse',
    abbrev: 'America/Whitehorse',
  },
  {
    name: 'GMT-7 America/Yellowknife : Yellowknife',
    abbrev: 'America/Yellowknife',
  },
  {
    name: 'GMT-6 America/Bahia_Banderas : Mezcales, San Vicente, Bucerías, Valle de Banderas',
    abbrev: 'America/Bahia_Banderas',
  },
  {
    name: 'GMT-6 America/Belize : Belize City, San Ignacio, Orange Walk, Belmopan, Dangriga',
    abbrev: 'America/Belize',
  },
  {
    name: 'GMT-6 America/Chicago : Chicago, Houston, San Antonio, Dallas, Austin',
    abbrev: 'America/Chicago',
  },
  {
    name: 'GMT-6 America/Costa_Rica : San José, Limón, San Francisco, Alajuela, Liberia',
    abbrev: 'America/Costa_Rica',
  },
  {
    name: 'GMT-6 America/El_Salvador : San Salvador, Soyapango, Santa Ana, San Miguel, Mejicanos',
    abbrev: 'America/El_Salvador',
  },
  {
    name:
      'GMT-6 America/Guatemala : Guatemala City, Mixco, Villa Nueva, Petapa, San Juan Sacatepéquez',
    abbrev: 'America/Guatemala',
  },
  {
    name: 'GMT-6 America/Indiana/Knox ',
    abbrev: 'America/Indiana/Knox',
  },
  {
    name: 'GMT-6 America/Indiana/Tell_City : Tell City',
    abbrev: 'America/Indiana/Tell_City',
  },
  {
    name: 'GMT-6 America/Managua : Managua, León, Masaya, Chinandega, Matagalpa',
    abbrev: 'America/Managua',
  },
  {
    name:
      'GMT-6 America/Matamoros : Reynosa, Heroica Matamoros, Nuevo Laredo, Piedras Negras, Ciudad Acuña',
    abbrev: 'America/Matamoros',
  },
  {
    name: 'GMT-6 America/Menominee : Menominee, Iron Mountain, Kingsford, Ironwood, Iron River',
    abbrev: 'America/Menominee',
  },
  {
    name: 'GMT-6 America/Merida : Mérida, Campeche, Ciudad del Carmen, Kanasín, Valladolid',
    abbrev: 'America/Merida',
  },
  {
    name:
      'GMT-6 America/Mexico_City : Mexico City, Iztapalapa, Ecatepec de Morelos, Guadalajara, Puebla',
    abbrev: 'America/Mexico_City',
  },
  {
    name: 'GMT-6 America/Monterrey : Monterrey, Saltillo, Guadalupe, Torreón, Victoria de Durango',
    abbrev: 'America/Monterrey',
  },
  {
    name: 'GMT-6 America/North_Dakota/Beulah ',
    abbrev: 'America/North_Dakota/Beulah',
  },
  {
    name: 'GMT-6 America/North_Dakota/Center ',
    abbrev: 'America/North_Dakota/Center',
  },
  {
    name: 'GMT-6 America/North_Dakota/New_Salem : Mandan',
    abbrev: 'America/North_Dakota/New_Salem',
  },
  {
    name: 'GMT-6 America/Rainy_River ',
    abbrev: 'America/Rainy_River',
  },
  {
    name: 'GMT-6 America/Rankin_Inlet ',
    abbrev: 'America/Rankin_Inlet',
  },
  {
    name: 'GMT-6 America/Regina : Saskatoon, Regina, Prince Albert, Moose Jaw, North Battleford',
    abbrev: 'America/Regina',
  },
  {
    name: 'GMT-6 America/Resolute ',
    abbrev: 'America/Resolute',
  },
  {
    name: 'GMT-6 America/Swift_Current : Swift Current',
    abbrev: 'America/Swift_Current',
  },
  {
    name: 'GMT-6 America/Tegucigalpa : Tegucigalpa, San Pedro Sula, Choloma, La Ceiba, El Progreso',
    abbrev: 'America/Tegucigalpa',
  },
  {
    name: 'GMT-6 America/Winnipeg : Winnipeg, Brandon, Kenora, Portage la Prairie, Thompson',
    abbrev: 'America/Winnipeg',
  },
  {
    name: 'GMT-6 Pacific/Easter ',
    abbrev: 'Pacific/Easter',
  },
  {
    name: 'GMT-6 Pacific/Galapagos : Puerto Ayora, Puerto Baquerizo Moreno',
    abbrev: 'Pacific/Galapagos',
  },
  {
    name: 'GMT-5 America/Atikokan ',
    abbrev: 'America/Atikokan',
  },
  {
    name: 'GMT-5 America/Bogota : Bogotá, Cali, Medellín, Barranquilla, Cartagena',
    abbrev: 'America/Bogota',
  },
  {
    name:
      'GMT-5 America/Cancun : Cancún, Chetumal, Playa del Carmen, Cozumel, Felipe Carrillo Puerto',
    abbrev: 'America/Cancun',
  },
  {
    name: 'GMT-5 America/Cayman : George Town, West Bay, Bodden Town, East End, North Side',
    abbrev: 'America/Cayman',
  },
  {
    name: 'GMT-5 America/Detroit : Detroit, Grand Rapids, Warren, Sterling Heights, Ann Arbor',
    abbrev: 'America/Detroit',
  },
  {
    name: 'GMT-5 America/Eirunepe : Eirunepé, Benjamin Constant, Envira',
    abbrev: 'America/Eirunepe',
  },
  {
    name: 'GMT-5 America/Grand_Turk : Cockburn Town',
    abbrev: 'America/Grand_Turk',
  },
  {
    name:
      'GMT-5 America/Guayaquil : Guayaquil, Quito, Cuenca, Santo Domingo de los Colorados, Machala',
    abbrev: 'America/Guayaquil',
  },
  {
    name: 'GMT-5 America/Havana : Havana, Santiago de Cuba, Camagüey, Holguín, Guantánamo',
    abbrev: 'America/Havana',
  },
  {
    name:
      'GMT-5 America/Indiana/Indianapolis : Indianapolis, Fort Wayne, South Bend, Carmel, Bloomington',
    abbrev: 'America/Indiana/Indianapolis',
  },
  {
    name: 'GMT-5 America/Indiana/Marengo ',
    abbrev: 'America/Indiana/Marengo',
  },
  {
    name: 'GMT-5 America/Indiana/Petersburg ',
    abbrev: 'America/Indiana/Petersburg',
  },
  {
    name: 'GMT-5 America/Indiana/Vevay ',
    abbrev: 'America/Indiana/Vevay',
  },
  {
    name: 'GMT-5 America/Indiana/Vincennes : Vincennes, Jasper, Washington, Huntingburg',
    abbrev: 'America/Indiana/Vincennes',
  },
  {
    name: 'GMT-5 America/Indiana/Winamac ',
    abbrev: 'America/Indiana/Winamac',
  },
  {
    name: 'GMT-5 America/Iqaluit : Iqaluit',
    abbrev: 'America/Iqaluit',
  },
  {
    name: 'GMT-5 America/Jamaica : Kingston, New Kingston, Spanish Town, Portmore, Montego Bay',
    abbrev: 'America/Jamaica',
  },
  {
    name:
      'GMT-5 America/Kentucky/Louisville : Louisville, Jeffersonville, New Albany, Jeffersontown, Pleasure Ridge Park',
    abbrev: 'America/Kentucky/Louisville',
  },
  {
    name: 'GMT-5 America/Kentucky/Monticello : Monticello',
    abbrev: 'America/Kentucky/Monticello',
  },
  {
    name: 'GMT-5 America/Lima : Lima, Arequipa, Callao, Trujillo, Chiclayo',
    abbrev: 'America/Lima',
  },
  {
    name: 'GMT-5 America/Nassau : Nassau, Lucaya, Freeport, West End, Cooper’s Town',
    abbrev: 'America/Nassau',
  },
  {
    name: 'GMT-5 America/New_York : New York City, Brooklyn, Queens, Philadelphia, Manhattan',
    abbrev: 'America/New_York',
  },
  {
    name: 'GMT-5 America/Nipigon ',
    abbrev: 'America/Nipigon',
  },
  {
    name: 'GMT-5 America/Panama : Panamá, San Miguelito, Juan Díaz, David, Arraiján',
    abbrev: 'America/Panama',
  },
  {
    name: 'GMT-5 America/Pangnirtung ',
    abbrev: 'America/Pangnirtung',
  },
  {
    name:
      'GMT-5 America/Port-au-Prince : Port-au-Prince, Carrefour, Delmas 73, Pétionville, Port-de-Paix',
    abbrev: 'America/Port-au-Prince',
  },
  {
    name: 'GMT-5 America/Rio_Branco : Rio Branco, Cruzeiro do Sul, Sena Madureira, Tarauacá, Feijó',
    abbrev: 'America/Rio_Branco',
  },
  {
    name: 'GMT-5 America/Thunder_Bay : Thunder Bay',
    abbrev: 'America/Thunder_Bay',
  },
  {
    name: 'GMT-5 America/Toronto : Toronto, Montréal, Ottawa, Mississauga, Québec',
    abbrev: 'America/Toronto',
  },
  {
    name:
      'GMT-4 America/Anguilla : The Valley, Blowing Point Village, Sandy Ground Village, West End Village, East End Village',
    abbrev: 'America/Anguilla',
  },
  {
    name: 'GMT-4 America/Antigua : Saint John’s, Piggotts, Bolands, Codrington, Parham',
    abbrev: 'America/Antigua',
  },
  {
    name: 'GMT-4 America/Aruba : Oranjestad, Tanki Leendert, San Nicolas, Santa Cruz, Paradera',
    abbrev: 'America/Aruba',
  },
  {
    name: 'GMT-4 America/Asuncion : Asunción, Ciudad del Este, San Lorenzo, Capiatá, Lambaré',
    abbrev: 'America/Asuncion',
  },
  {
    name: 'GMT-4 America/Barbados : Bridgetown, Speightstown, Oistins, Bathsheba, Holetown',
    abbrev: 'America/Barbados',
  },
  {
    name: 'GMT-4 America/Blanc-Sablon : Lévis',
    abbrev: 'America/Blanc-Sablon',
  },
  {
    name: 'GMT-4 America/Boa_Vista : Boa Vista',
    abbrev: 'America/Boa_Vista',
  },
  {
    name: 'GMT-4 America/Campo_Grande : Campo Grande, Dourados, Corumbá, Três Lagoas, Ponta Porã',
    abbrev: 'America/Campo_Grande',
  },
  {
    name: 'GMT-4 America/Caracas : Caracas, Maracaibo, Maracay, Valencia, Barquisimeto',
    abbrev: 'America/Caracas',
  },
  {
    name: 'GMT-4 America/Cuiaba : Cuiabá, Várzea Grande, Rondonópolis, Sinop, Barra do Garças',
    abbrev: 'America/Cuiaba',
  },
  {
    name: 'GMT-4 America/Curacao : Willemstad, Sint Michiel Liber',
    abbrev: 'America/Curacao',
  },
  {
    name: 'GMT-4 America/Dominica : Roseau, Portsmouth, Berekua, Saint Joseph, Wesley',
    abbrev: 'America/Dominica',
  },
  {
    name: 'GMT-4 America/Glace_Bay : Sydney, Glace Bay, Sydney Mines',
    abbrev: 'America/Glace_Bay',
  },
  {
    name: 'GMT-4 America/Goose_Bay : Labrador City, Happy Valley-Goose Bay',
    abbrev: 'America/Goose_Bay',
  },
  {
    name: "GMT-4 America/Grenada : Saint George's, Gouyave, Grenville, Victoria, Saint David’s",
    abbrev: 'America/Grenada',
  },
  {
    name:
      'GMT-4 America/Guadeloupe : Les Abymes, Baie-Mahault, Le Gosier, Petit-Bourg, Sainte-Anne',
    abbrev: 'America/Guadeloupe',
  },
  {
    name: 'GMT-4 America/Guyana : Georgetown, Linden, New Amsterdam, Anna Regina, Bartica',
    abbrev: 'America/Guyana',
  },
  {
    name: 'GMT-4 America/Halifax : Halifax, Dartmouth, Charlottetown, Lower Sackville, Truro',
    abbrev: 'America/Halifax',
  },
  {
    name: 'GMT-4 America/Kralendijk : Kralendijk, Oranjestad, The Bottom',
    abbrev: 'America/Kralendijk',
  },
  {
    name: 'GMT-4 America/La_Paz : Santa Cruz de la Sierra, Cochabamba, La Paz, Sucre, Oruro',
    abbrev: 'America/La_Paz',
  },
  {
    name: 'GMT-4 America/Lower_Princes : Cul de Sac, Lower Prince’s Quarter, Koolbaai, Philipsburg',
    abbrev: 'America/Lower_Princes',
  },
  {
    name: 'GMT-4 America/Manaus : Manaus, Itacoatiara, Parintins, Manacapuru, Coari',
    abbrev: 'America/Manaus',
  },
  {
    name: 'GMT-4 America/Marigot : Marigot',
    abbrev: 'America/Marigot',
  },
  {
    name:
      'GMT-4 America/Martinique : Fort-de-France, Le Lamentin, Le Robert, Sainte-Marie, Le François',
    abbrev: 'America/Martinique',
  },
  {
    name: 'GMT-4 America/Moncton : Moncton, Saint John, Fredericton, Dieppe, Miramichi',
    abbrev: 'America/Moncton',
  },
  {
    name: 'GMT-4 America/Montserrat : Brades, Saint Peters, Plymouth',
    abbrev: 'America/Montserrat',
  },
  {
    name: 'GMT-4 America/Porto_Velho : Porto Velho, Ji Paraná, Vilhena, Ariquemes, Cacoal',
    abbrev: 'America/Porto_Velho',
  },
  {
    name:
      'GMT-4 America/Port_of_Spain : Chaguanas, Mon Repos, San Fernando, Port of Spain, Rio Claro',
    abbrev: 'America/Port_of_Spain',
  },
  {
    name: 'GMT-4 America/Puerto_Rico : San Juan, Bayamón, Carolina, Ponce, Caguas',
    abbrev: 'America/Puerto_Rico',
  },
  {
    name: 'GMT-4 America/Santiago : Santiago, Puente Alto, Antofagasta, Viña del Mar, Valparaíso',
    abbrev: 'America/Santiago',
  },
  {
    name:
      'GMT-4 America/Santo_Domingo : Santo Domingo, Santiago de los Caballeros, Santo Domingo Oeste, Santo Domingo Este, San Pedro de Macorís',
    abbrev: 'America/Santo_Domingo',
  },
  {
    name: 'GMT-4 America/St_Barthelemy : Gustavia',
    abbrev: 'America/St_Barthelemy',
  },
  {
    name: 'GMT-4 America/St_Kitts : Basseterre, Fig Tree, Market Shop, Saint Paul’s, Middle Island',
    abbrev: 'America/St_Kitts',
  },
  {
    name: 'GMT-4 America/St_Lucia : Castries, Bisee, Vieux Fort, Micoud, Soufrière',
    abbrev: 'America/St_Lucia',
  },
  {
    name: 'GMT-4 America/St_Thomas : Saint Croix, Charlotte Amalie, Cruz Bay',
    abbrev: 'America/St_Thomas',
  },
  {
    name:
      'GMT-4 America/St_Vincent : Kingstown, Kingstown Park, Georgetown, Barrouallie, Port Elizabeth',
    abbrev: 'America/St_Vincent',
  },
  {
    name: 'GMT-4 America/Thule ',
    abbrev: 'America/Thule',
  },
  {
    name: 'GMT-4 America/Tortola : Road Town',
    abbrev: 'America/Tortola',
  },
  {
    name: 'GMT-4 Atlantic/Bermuda : Hamilton',
    abbrev: 'Atlantic/Bermuda',
  },
  {
    name:
      "GMT-3:30 America/St_Johns : St. John's, Mount Pearl, Corner Brook, Conception Bay South, Bay Roberts",
    abbrev: 'America/St_Johns',
  },
  {
    name:
      'GMT-3 America/Araguaina : Palmas, Araguaína, Gurupi, Miracema do Tocantins, Porto Franco',
    abbrev: 'America/Araguaina',
  },
  {
    name:
      'GMT-3 America/Argentina/Buenos_Aires : Buenos Aires, La Plata, Mar del Plata, Morón, Bahía Blanca',
    abbrev: 'America/Argentina/Buenos_Aires',
  },
  {
    name:
      'GMT-3 America/Argentina/Catamarca : San Fernando del Valle de Catamarca, Trelew, Puerto Madryn, Esquel, Rawson',
    abbrev: 'America/Argentina/Catamarca',
  },
  {
    name:
      'GMT-3 America/Argentina/Cordoba : Córdoba, Rosario, Santa Fe, Resistencia, Santiago del Estero',
    abbrev: 'America/Argentina/Cordoba',
  },
  {
    name:
      'GMT-3 America/Argentina/Jujuy : San Salvador de Jujuy, San Pedro de Jujuy, Libertador General San Martín, Palpalá, La Quiaca',
    abbrev: 'America/Argentina/Jujuy',
  },
  {
    name: 'GMT-3 America/Argentina/La_Rioja : La Rioja, Chilecito, Arauco, Chamical',
    abbrev: 'America/Argentina/La_Rioja',
  },
  {
    name: 'GMT-3 America/Argentina/Mendoza : Mendoza, San Rafael, San Martín',
    abbrev: 'America/Argentina/Mendoza',
  },
  {
    name:
      'GMT-3 America/Argentina/Rio_Gallegos : Comodoro Rivadavia, Río Gallegos, Caleta Olivia, Pico Truncado, Puerto Deseado',
    abbrev: 'America/Argentina/Rio_Gallegos',
  },
  {
    name:
      'GMT-3 America/Argentina/Salta : Salta, Neuquén, Santa Rosa, San Carlos de Bariloche, Cipolletti',
    abbrev: 'America/Argentina/Salta',
  },
  {
    name: 'GMT-3 America/Argentina/San_Juan : San Juan, Chimbas, Santa Lucía, Pocito, Caucete',
    abbrev: 'America/Argentina/San_Juan',
  },
  {
    name:
      'GMT-3 America/Argentina/San_Luis : San Luis, Villa Mercedes, La Punta, Merlo, Justo Daract',
    abbrev: 'America/Argentina/San_Luis',
  },
  {
    name:
      'GMT-3 America/Argentina/Tucuman : San Miguel de Tucumán, Yerba Buena, Tafí Viejo, Alderetes, Aguilares',
    abbrev: 'America/Argentina/Tucuman',
  },
  {
    name: 'GMT-3 America/Argentina/Ushuaia : Ushuaia, Río Grande',
    abbrev: 'America/Argentina/Ushuaia',
  },
  {
    name:
      'GMT-3 America/Bahia : Salvador, Feira de Santana, Vitória da Conquista, Itabuna, Camaçari',
    abbrev: 'America/Bahia',
  },
  {
    name: 'GMT-3 America/Belem : Belém, Ananindeua, Macapá, Parauapebas, Marabá',
    abbrev: 'America/Belem',
  },
  {
    name:
      'GMT-3 America/Cayenne : Cayenne, Matoury, Saint-Laurent-du-Maroni, Kourou, Rémire-Montjoly',
    abbrev: 'America/Cayenne',
  },
  {
    name: 'GMT-3 America/Fortaleza : Fortaleza, São Luís, Natal, Teresina, João Pessoa',
    abbrev: 'America/Fortaleza',
  },
  {
    name: 'GMT-3 America/Godthab : Nuuk, Sisimiut, Ilulissat, Qaqortoq, Aasiaat',
    abbrev: 'America/Godthab',
  },
  {
    name:
      'GMT-3 America/Maceio : Maceió, Aracaju, Arapiraca, Nossa Senhora do Socorro, São Cristóvão',
    abbrev: 'America/Maceio',
  },
  {
    name: 'GMT-3 America/Miquelon : Saint-Pierre, Miquelon',
    abbrev: 'America/Miquelon',
  },
  {
    name: 'GMT-3 America/Montevideo : Montevideo, Salto, Paysandú, Las Piedras, Rivera',
    abbrev: 'America/Montevideo',
  },
  {
    name: 'GMT-3 America/Paramaribo : Paramaribo, Lelydorp, Brokopondo, Nieuw Nickerie, Moengo',
    abbrev: 'America/Paramaribo',
  },
  {
    name: 'GMT-3 America/Punta_Arenas : Punta Arenas, Puerto Natales',
    abbrev: 'America/Punta_Arenas',
  },
  {
    name: 'GMT-3 America/Recife : Recife, Jaboatão, Jaboatão dos Guararapes, Olinda, Paulista',
    abbrev: 'America/Recife',
  },
  {
    name: 'GMT-3 America/Santarem : Santarém, Altamira, Itaituba, Oriximiná, Alenquer',
    abbrev: 'America/Santarem',
  },
  {
    name: 'GMT-3 America/Sao_Paulo : São Paulo, Rio de Janeiro, Belo Horizonte, Brasília, Curitiba',
    abbrev: 'America/Sao_Paulo',
  },
  {
    name: 'GMT-3 Antarctica/Palmer ',
    abbrev: 'Antarctica/Palmer',
  },
  {
    name: 'GMT-3 Antarctica/Rothera : La Legua-San Jacinto',
    abbrev: 'Antarctica/Rothera',
  },
  {
    name: 'GMT-3 Atlantic/Stanley : Stanley',
    abbrev: 'Atlantic/Stanley',
  },
  {
    name: 'GMT-2 America/Noronha : Itamaracá',
    abbrev: 'America/Noronha',
  },
  {
    name: 'GMT-2 Atlantic/South_Georgia : Grytviken',
    abbrev: 'Atlantic/South_Georgia',
  },
  {
    name: 'GMT-1 America/Scoresbysund ',
    abbrev: 'America/Scoresbysund',
  },
  {
    name:
      'GMT-1 Atlantic/Azores : Ponta Delgada, Lagoa, Angra do Heroísmo, Rosto de Cão, Rabo de Peixe',
    abbrev: 'Atlantic/Azores',
  },
  {
    name: 'GMT-1 Atlantic/Cape_Verde : Praia, Mindelo, Santa Maria, Cova Figueira, Santa Cruz',
    abbrev: 'Atlantic/Cape_Verde',
  },
  {
    name: 'GMT+0 Africa/Abidjan : Abidjan, Abobo, Bouaké, Daloa, San-Pédro',
    abbrev: 'Africa/Abidjan',
  },
  {
    name: 'GMT+0 Africa/Accra : Accra, Kumasi, Tamale, Takoradi, Atsiaman',
    abbrev: 'Africa/Accra',
  },
  {
    name: 'GMT+0 Africa/Bamako : Bamako, Sikasso, Mopti, Koutiala, Ségou',
    abbrev: 'Africa/Bamako',
  },
  {
    name: 'GMT+0 Africa/Banjul : Serekunda, Brikama, Bakau, Banjul, Farafenni',
    abbrev: 'Africa/Banjul',
  },
  {
    name: 'GMT+0 Africa/Bissau : Bissau, Bafatá, Gabú, Bissorã, Bolama',
    abbrev: 'Africa/Bissau',
  },
  {
    name: 'GMT+0 Africa/Conakry : Camayenne, Conakry, Nzérékoré, Kindia, Kankan',
    abbrev: 'Africa/Conakry',
  },
  {
    name: 'GMT+0 Africa/Dakar : Dakar, Pikine, Touba, Thiès, Thiès Nones',
    abbrev: 'Africa/Dakar',
  },
  {
    name: 'GMT+0 Africa/Freetown : Freetown, Bo, Kenema, Koidu, Makeni',
    abbrev: 'Africa/Freetown',
  },
  {
    name: 'GMT+0 Africa/Lome : Lomé, Sokodé, Kara, Atakpamé, Kpalimé',
    abbrev: 'Africa/Lome',
  },
  {
    name: 'GMT+0 Africa/Monrovia : Monrovia, Gbarnga, Kakata, Bensonville, Harper',
    abbrev: 'Africa/Monrovia',
  },
  {
    name: 'GMT+0 Africa/Nouakchott : Nouakchott, Nouadhibou, Néma, Kaédi, Rosso',
    abbrev: 'Africa/Nouakchott',
  },
  {
    name: 'GMT+0 Africa/Ouagadougou : Ouagadougou, Bobo-Dioulasso, Koudougou, Ouahigouya, Banfora',
    abbrev: 'Africa/Ouagadougou',
  },
  {
    name: 'GMT+0 Africa/Sao_Tome : São Tomé, Santo António',
    abbrev: 'Africa/Sao_Tome',
  },
  {
    name: 'GMT+0 America/Danmarkshavn ',
    abbrev: 'America/Danmarkshavn',
  },
  {
    name: 'GMT+0 Antarctica/Troll ',
    abbrev: 'Antarctica/Troll',
  },
  {
    name:
      'GMT+0 Atlantic/Canary : Las Palmas de Gran Canaria, Santa Cruz de Tenerife, La Laguna, Telde, Arona',
    abbrev: 'Atlantic/Canary',
  },
  {
    name: 'GMT+0 Atlantic/Faroe : Tórshavn, Klaksvík, Fuglafjørður, Tvøroyri, Miðvágur',
    abbrev: 'Atlantic/Faroe',
  },
  {
    name: 'GMT+0 Atlantic/Madeira : Funchal, Câmara de Lobos, São Martinho, Caniço, Machico',
    abbrev: 'Atlantic/Madeira',
  },
  {
    name: 'GMT+0 Atlantic/Reykjavik : Reykjavík, Kópavogur, Hafnarfjörður, Akureyri, Garðabær',
    abbrev: 'Atlantic/Reykjavik',
  },
  {
    name: 'GMT+0 Atlantic/St_Helena : Jamestown, Georgetown, Edinburgh of the Seven Seas',
    abbrev: 'Atlantic/St_Helena',
  },
  {
    name:
      'GMT+0 Europe/Guernsey : Saint Peter Port, Torteval, Saint Sampson, St Anne, Saint Saviour',
    abbrev: 'Europe/Guernsey',
  },
  {
    name: 'GMT+0 Europe/Isle_of_Man : Douglas, Ramsey, Peel, Port Erin, Castletown',
    abbrev: 'Europe/Isle_of_Man',
  },
  {
    name: 'GMT+0 Europe/Jersey : Saint Helier, Le Hocq',
    abbrev: 'Europe/Jersey',
  },
  {
    name: 'GMT+0 Europe/Lisbon : Lisbon, Porto, Amadora, Braga, Setúbal',
    abbrev: 'Europe/Lisbon',
  },
  {
    name: 'GMT+0 Europe/London : London, Birmingham, Liverpool, Nottingham, Sheffield',
    abbrev: 'Europe/London',
  },
  {
    name: 'GMT+1 Africa/Algiers : Algiers, Boumerdas, Oran, Tébessa, Constantine',
    abbrev: 'Africa/Algiers',
  },
  {
    name: 'GMT+1 Africa/Bangui : Bangui, Bimbo, Mbaïki, Berbérati, Kaga Bandoro',
    abbrev: 'Africa/Bangui',
  },
  {
    name: 'GMT+1 Africa/Brazzaville : Brazzaville, Pointe-Noire, Dolisie, Kayes, Owando',
    abbrev: 'Africa/Brazzaville',
  },
  {
    name: 'GMT+1 Africa/Casablanca : Casablanca, Rabat, Fès, Sale, Marrakesh',
    abbrev: 'Africa/Casablanca',
  },
  {
    name: 'GMT+1 Africa/Ceuta : Ceuta, Melilla',
    abbrev: 'Africa/Ceuta',
  },
  {
    name: 'GMT+1 Africa/Douala : Douala, Yaoundé, Garoua, Kousséri, Bamenda',
    abbrev: 'Africa/Douala',
  },
  {
    name: 'GMT+1 Africa/El_Aaiun : Laayoune, Dakhla, Laayoune Plage',
    abbrev: 'Africa/El_Aaiun',
  },
  {
    name: 'GMT+1 Africa/Kinshasa : Kinshasa, Masina, Kikwit, Mbandaka, Matadi',
    abbrev: 'Africa/Kinshasa',
  },
  {
    name: 'GMT+1 Africa/Lagos : Lagos, Kano, Ibadan, Kaduna, Port Harcourt',
    abbrev: 'Africa/Lagos',
  },
  {
    name: 'GMT+1 Africa/Libreville : Libreville, Port-Gentil, Franceville, Oyem, Moanda',
    abbrev: 'Africa/Libreville',
  },
  {
    name: 'GMT+1 Africa/Luanda : Luanda, N’dalatando, Huambo, Lobito, Benguela',
    abbrev: 'Africa/Luanda',
  },
  {
    name: 'GMT+1 Africa/Malabo : Bata, Malabo, Ebebiyin, Aconibe, Añisoc',
    abbrev: 'Africa/Malabo',
  },
  {
    name: "GMT+1 Africa/Ndjamena : N'Djamena, Moundou, Sarh, Abéché, Kelo",
    abbrev: 'Africa/Ndjamena',
  },
  {
    name: 'GMT+1 Africa/Niamey : Niamey, Zinder, Maradi, Agadez, Alaghsas',
    abbrev: 'Africa/Niamey',
  },
  {
    name: 'GMT+1 Africa/Porto-Novo : Cotonou, Abomey-Calavi, Djougou, Porto-Novo, Parakou',
    abbrev: 'Africa/Porto-Novo',
  },
  {
    name: 'GMT+1 Africa/Tunis : Tunis, Sfax, Sousse, Kairouan, Bizerte',
    abbrev: 'Africa/Tunis',
  },
  {
    name: 'GMT+1 Arctic/Longyearbyen : Longyearbyen, Olonkinbyen',
    abbrev: 'Arctic/Longyearbyen',
  },
  {
    name: 'GMT+1 Europe/Amsterdam : Amsterdam, Rotterdam, The Hague, Utrecht, Eindhoven',
    abbrev: 'Europe/Amsterdam',
  },
  {
    name:
      'GMT+1 Europe/Andorra : Andorra la Vella, les Escaldes, Encamp, Sant Julià de Lòria, la Massana',
    abbrev: 'Europe/Andorra',
  },
  {
    name: 'GMT+1 Europe/Belgrade : Belgrade, Pristina, Niš, Novi Sad, Prizren',
    abbrev: 'Europe/Belgrade',
  },
  {
    name: 'GMT+1 Europe/Berlin : Berlin, Hamburg, Munich, Köln, Frankfurt am Main',
    abbrev: 'Europe/Berlin',
  },
  {
    name: 'GMT+1 Europe/Bratislava : Bratislava, Košice, Prešov, Nitra, Žilina',
    abbrev: 'Europe/Bratislava',
  },
  {
    name: 'GMT+1 Europe/Brussels : Brussels, Antwerpen, Gent, Charleroi, Liège',
    abbrev: 'Europe/Brussels',
  },
  {
    name: 'GMT+1 Europe/Budapest : Budapest, Debrecen, Miskolc, Szeged, Pécs',
    abbrev: 'Europe/Budapest',
  },
  {
    name: 'GMT+1 Europe/Copenhagen : Copenhagen, Århus, Odense, Aalborg, Frederiksberg',
    abbrev: 'Europe/Copenhagen',
  },
  {
    name: 'GMT+1 Europe/Dublin : Dublin, Cork, Luimneach, Gaillimh, Tallaght',
    abbrev: 'Europe/Dublin',
  },
  {
    name: 'GMT+1 Europe/Gibraltar : Gibraltar',
    abbrev: 'Europe/Gibraltar',
  },
  {
    name: 'GMT+1 Europe/Ljubljana : Ljubljana, Maribor, Celje, Kranj, Velenje',
    abbrev: 'Europe/Ljubljana',
  },
  {
    name:
      'GMT+1 Europe/Luxembourg : Luxembourg, Esch-sur-Alzette, Dudelange, Schifflange, Bettembourg',
    abbrev: 'Europe/Luxembourg',
  },
  {
    name: 'GMT+1 Europe/Madrid : Madrid, Barcelona, Valencia, Sevilla, Zaragoza',
    abbrev: 'Europe/Madrid',
  },
  {
    name: 'GMT+1 Europe/Malta : Birkirkara, Qormi, Mosta, Żabbar, San Pawl il-Baħar',
    abbrev: 'Europe/Malta',
  },
  {
    name: 'GMT+1 Europe/Monaco : Monaco, Monte-Carlo, La Condamine',
    abbrev: 'Europe/Monaco',
  },
  {
    name: 'GMT+1 Europe/Oslo : Oslo, Bergen, Trondheim, Stavanger, Drammen',
    abbrev: 'Europe/Oslo',
  },
  {
    name: 'GMT+1 Europe/Paris : Paris, Marseille, Lyon, Toulouse, Nice',
    abbrev: 'Europe/Paris',
  },
  {
    name: 'GMT+1 Europe/Podgorica : Podgorica, Nikšić, Herceg Novi, Pljevlja, Budva',
    abbrev: 'Europe/Podgorica',
  },
  {
    name: 'GMT+1 Europe/Prague : Prague, Brno, Ostrava, Pilsen, Olomouc',
    abbrev: 'Europe/Prague',
  },
  {
    name: 'GMT+1 Europe/Rome : Rome, Milan, Naples, Turin, Palermo',
    abbrev: 'Europe/Rome',
  },
  {
    name: 'GMT+1 Europe/San_Marino : Serravalle, Borgo Maggiore, San Marino, Domagnano, Fiorentino',
    abbrev: 'Europe/San_Marino',
  },
  {
    name: 'GMT+1 Europe/Sarajevo : Sarajevo, Banja Luka, Zenica, Tuzla, Mostar',
    abbrev: 'Europe/Sarajevo',
  },
  {
    name: 'GMT+1 Europe/Skopje : Skopje, Bitola, Kumanovo, Prilep, Tetovo',
    abbrev: 'Europe/Skopje',
  },
  {
    name: 'GMT+1 Europe/Stockholm : Stockholm, Göteborg, Malmö, Uppsala, Sollentuna',
    abbrev: 'Europe/Stockholm',
  },
  {
    name: 'GMT+1 Europe/Tirane : Tirana, Durrës, Elbasan, Vlorë, Shkodër',
    abbrev: 'Europe/Tirane',
  },
  {
    name: 'GMT+1 Europe/Vaduz : Schaan, Vaduz, Triesen, Balzers, Eschen',
    abbrev: 'Europe/Vaduz',
  },
  {
    name: 'GMT+1 Europe/Vatican : Vatican City',
    abbrev: 'Europe/Vatican',
  },
  {
    name: 'GMT+1 Europe/Vienna : Vienna, Graz, Linz, Favoriten, Donaustadt',
    abbrev: 'Europe/Vienna',
  },
  {
    name: 'GMT+1 Europe/Warsaw : Warsaw, Łódź, Kraków, Wrocław, Poznań',
    abbrev: 'Europe/Warsaw',
  },
  {
    name: 'GMT+1 Europe/Zagreb : Zagreb, Split, Rijeka, Osijek, Zadar',
    abbrev: 'Europe/Zagreb',
  },
  {
    name: 'GMT+1 Europe/Zurich : Zürich, Genève, Basel, Bern, Lausanne',
    abbrev: 'Europe/Zurich',
  },
  {
    name: 'GMT+2 Africa/Blantyre : Lilongwe, Blantyre, Mzuzu, Zomba, Kasungu',
    abbrev: 'Africa/Blantyre',
  },
  {
    name: 'GMT+2 Africa/Bujumbura : Bujumbura, Muyinga, Gitega, Ruyigi, Ngozi',
    abbrev: 'Africa/Bujumbura',
  },
  {
    name: 'GMT+2 Africa/Cairo : Cairo, Alexandria, Giza, Port Said, Suez',
    abbrev: 'Africa/Cairo',
  },
  {
    name: 'GMT+2 Africa/Gaborone : Gaborone, Francistown, Molepolole, Selebi-Phikwe, Maun',
    abbrev: 'Africa/Gaborone',
  },
  {
    name: 'GMT+2 Africa/Harare : Harare, Bulawayo, Chitungwiza, Mutare, Gweru',
    abbrev: 'Africa/Harare',
  },
  {
    name: 'GMT+2 Africa/Johannesburg : Cape Town, Durban, Johannesburg, Soweto, Pretoria',
    abbrev: 'Africa/Johannesburg',
  },
  {
    name: 'GMT+2 Africa/Khartoum : Khartoum, Omdurman, Nyala, Port Sudan, Kassala',
    abbrev: 'Africa/Khartoum',
  },
  {
    name: 'GMT+2 Africa/Kigali : Kigali, Butare, Gitarama, Musanze, Gisenyi',
    abbrev: 'Africa/Kigali',
  },
  {
    name: 'GMT+2 Africa/Lubumbashi : Lubumbashi, Mbuji-Mayi, Kisangani, Kananga, Likasi',
    abbrev: 'Africa/Lubumbashi',
  },
  {
    name: 'GMT+2 Africa/Lusaka : Lusaka, Kitwe, Ndola, Kabwe, Chingola',
    abbrev: 'Africa/Lusaka',
  },
  {
    name: 'GMT+2 Africa/Maputo : Maputo, Matola, Beira, Nampula, Chimoio',
    abbrev: 'Africa/Maputo',
  },
  {
    name: 'GMT+2 Africa/Maseru : Maseru, Mafeteng, Leribe, Maputsoe, Mohale’s Hoek',
    abbrev: 'Africa/Maseru',
  },
  {
    name: 'GMT+2 Africa/Mbabane : Manzini, Mbabane, Big Bend, Malkerns, Nhlangano',
    abbrev: 'Africa/Mbabane',
  },
  {
    name: 'GMT+2 Africa/Tripoli : Tripoli, Benghazi, Mişrātah, Tarhuna, Al Khums',
    abbrev: 'Africa/Tripoli',
  },
  {
    name: 'GMT+2 Africa/Windhoek : Windhoek, Rundu, Walvis Bay, Oshakati, Swakopmund',
    abbrev: 'Africa/Windhoek',
  },
  {
    name: 'GMT+2 Asia/Amman : Amman, Zarqa, Irbid, Russeifa, Wādī as Sīr',
    abbrev: 'Asia/Amman',
  },
  {
    name: 'GMT+2 Asia/Beirut : Beirut, Ra’s Bayrūt, Tripoli, Sidon, Tyre',
    abbrev: 'Asia/Beirut',
  },
  {
    name: 'GMT+2 Asia/Damascus : Aleppo, Damascus, Homs, Ḩamāh, Latakia',
    abbrev: 'Asia/Damascus',
  },
  {
    name: 'GMT+2 Asia/Famagusta : Famagusta, Kyrenia, Protaras, Paralímni, Rizokárpaso',
    abbrev: 'Asia/Famagusta',
  },
  {
    name: 'GMT+2 Asia/Gaza : Gaza, Khān Yūnis, Jabālyā, Rafaḩ, Dayr al Balaḩ',
    abbrev: 'Asia/Gaza',
  },
  {
    name: 'GMT+2 Asia/Hebron : East Jerusalem, Hebron, Nablus, Battir, Ţūlkarm',
    abbrev: 'Asia/Hebron',
  },
  {
    name: 'GMT+2 Asia/Jerusalem : Jerusalem, Tel Aviv, West Jerusalem, Haifa, Ashdod',
    abbrev: 'Asia/Jerusalem',
  },
  {
    name: 'GMT+2 Asia/Nicosia : Nicosia, Limassol, Larnaca, Stróvolos, Paphos',
    abbrev: 'Asia/Nicosia',
  },
  {
    name: 'GMT+2 Europe/Athens : Athens, Thessaloníki, Pátra, Piraeus, Lárisa',
    abbrev: 'Europe/Athens',
  },
  {
    name: 'GMT+2 Europe/Bucharest : Bucharest, Sector 3, Sector 6, Sector 2, Iaşi',
    abbrev: 'Europe/Bucharest',
  },
  {
    name: 'GMT+2 Europe/Chisinau : Chisinau, Tiraspol, Bălţi, Bender, Rîbniţa',
    abbrev: 'Europe/Chisinau',
  },
  {
    name: 'GMT+2 Europe/Helsinki : Helsinki, Espoo, Tampere, Vantaa, Turku',
    abbrev: 'Europe/Helsinki',
  },
  {
    name: 'GMT+2 Europe/Kaliningrad : Kaliningrad, Chernyakhovsk, Sovetsk, Baltiysk, Gusev',
    abbrev: 'Europe/Kaliningrad',
  },
  {
    name: 'GMT+2 Europe/Kiev : Kyiv, Kharkiv, Dnipro, Donetsk, Odessa',
    abbrev: 'Europe/Kiev',
  },
  {
    name: 'GMT+2 Europe/Mariehamn : Mariehamn',
    abbrev: 'Europe/Mariehamn',
  },
  {
    name: 'GMT+2 Europe/Riga : Riga, Daugavpils, Liepāja, Jelgava, Jūrmala',
    abbrev: 'Europe/Riga',
  },
  {
    name: 'GMT+2 Europe/Sofia : Sofia, Plovdiv, Varna, Burgas, Ruse',
    abbrev: 'Europe/Sofia',
  },
  {
    name: 'GMT+2 Europe/Tallinn : Tallinn, Tartu, Narva, Kohtla-Järve, Pärnu',
    abbrev: 'Europe/Tallinn',
  },
  {
    name: 'GMT+2 Europe/Uzhgorod : Uzhgorod, Mukachevo, Khust, Berehove, Tyachiv',
    abbrev: 'Europe/Uzhgorod',
  },
  {
    name: 'GMT+2 Europe/Vilnius : Vilnius, Kaunas, Klaipėda, Šiauliai, Panevėžys',
    abbrev: 'Europe/Vilnius',
  },
  {
    name: 'GMT+2 Europe/Zaporozhye : Zaporizhia, Luhansk, Sevastopol, Melitopol, Syevyerodonets’k',
    abbrev: 'Europe/Zaporozhye',
  },
  {
    name: "GMT+3 Africa/Addis_Ababa : Addis Ababa, Dire Dawa, Mek'ele, Nazrēt, Bahir Dar",
    abbrev: 'Africa/Addis_Ababa',
  },
  {
    name: 'GMT+3 Africa/Asmara : Asmara, Keren, Massawa, Assab, Mendefera',
    abbrev: 'Africa/Asmara',
  },
  {
    name: 'GMT+3 Africa/Dar_es_Salaam : Dar es Salaam, Mwanza, Zanzibar, Arusha, Mbeya',
    abbrev: 'Africa/Dar_es_Salaam',
  },
  {
    name: "GMT+3 Africa/Djibouti : Djibouti, 'Ali Sabieh, Tadjourah, Obock, Dikhil",
    abbrev: 'Africa/Djibouti',
  },
  {
    name: 'GMT+3 Africa/Juba : Juba, Winejok, Malakal, Wau, Pajok',
    abbrev: 'Africa/Juba',
  },
  {
    name: 'GMT+3 Africa/Kampala : Kampala, Gulu, Lira, Mbarara, Jinja',
    abbrev: 'Africa/Kampala',
  },
  {
    name: 'GMT+3 Africa/Mogadishu : Mogadishu, Hargeysa, Berbera, Kismayo, Marka',
    abbrev: 'Africa/Mogadishu',
  },
  {
    name: 'GMT+3 Africa/Nairobi : Nairobi, Mombasa, Nakuru, Eldoret, Kisumu',
    abbrev: 'Africa/Nairobi',
  },
  {
    name: 'GMT+3 Antarctica/Syowa ',
    abbrev: 'Antarctica/Syowa',
  },
  {
    name: 'GMT+3 Asia/Aden : Sanaa, Al Ḩudaydah, Ta‘izz, Aden, Mukalla',
    abbrev: 'Asia/Aden',
  },
  {
    name: 'GMT+3 Asia/Baghdad : Baghdad, Basrah, Al Mawşil al Jadīdah, Al Başrah al Qadīmah, Mosul',
    abbrev: 'Asia/Baghdad',
  },
  {
    name: 'GMT+3 Asia/Bahrain : Manama, Al Muharraq, Ar Rifā‘, Dār Kulayb, Madīnat Ḩamad',
    abbrev: 'Asia/Bahrain',
  },
  {
    name: 'GMT+3 Asia/Kuwait : Al Aḩmadī, Ḩawallī, As Sālimīyah, Şabāḩ as Sālim, Al Farwānīyah',
    abbrev: 'Asia/Kuwait',
  },
  {
    name: 'GMT+3 Asia/Qatar : Doha, Ar Rayyān, Umm Şalāl Muḩammad, Al Wakrah, Al Khawr',
    abbrev: 'Asia/Qatar',
  },
  {
    name: 'GMT+3 Asia/Riyadh : Riyadh, Jeddah, Mecca, Medina, Sulţānah',
    abbrev: 'Asia/Riyadh',
  },
  {
    name: 'GMT+3 Europe/Istanbul : Istanbul, Ankara, İzmir, Bursa, Adana',
    abbrev: 'Europe/Istanbul',
  },
  {
    name: 'GMT+3 Europe/Kirov : Kirov, Kirovo-Chepetsk, Vyatskiye Polyany, Slobodskoy, Kotel’nich',
    abbrev: 'Europe/Kirov',
  },
  {
    name: "GMT+3 Europe/Minsk : Minsk, Homyel', Mahilyow, Vitebsk, Hrodna",
    abbrev: 'Europe/Minsk',
  },
  {
    name: 'GMT+3 Europe/Moscow : Moscow, Saint Petersburg, Nizhniy Novgorod, Kazan, Rostov-na-Donu',
    abbrev: 'Europe/Moscow',
  },
  {
    name: 'GMT+3 Europe/Simferopol : Simferopol, Kerch, Yevpatoriya, Yalta, Feodosiya',
    abbrev: 'Europe/Simferopol',
  },
  {
    name: 'GMT+3 Indian/Antananarivo : Antananarivo, Toamasina, Antsirabe, Fianarantsoa, Mahajanga',
    abbrev: 'Indian/Antananarivo',
  },
  {
    name: 'GMT+3 Indian/Comoro : Moroni, Moutsamoudou, Fomboni, Domoni, Tsimbeo',
    abbrev: 'Indian/Comoro',
  },
  {
    name: 'GMT+3 Indian/Mayotte : Mamoudzou, Koungou, Dzaoudzi, Dembeni, Sada',
    abbrev: 'Indian/Mayotte',
  },
  {
    name: 'GMT+3:30 Asia/Tehran : Tehran, Mashhad, Isfahan, Karaj, Tabriz',
    abbrev: 'Asia/Tehran',
  },
  {
    name: 'GMT+4 Asia/Baku : Baku, Ganja, Sumqayıt, Lankaran, Yevlakh',
    abbrev: 'Asia/Baku',
  },
  {
    name: 'GMT+4 Asia/Dubai : Dubai, Sharjah, Abu Dhabi, Ajman City, Ras Al Khaimah City',
    abbrev: 'Asia/Dubai',
  },
  {
    name: 'GMT+4 Asia/Muscat : Muscat, Seeb, Şalālah, Bawshar, Sohar',
    abbrev: 'Asia/Muscat',
  },
  {
    name: 'GMT+4 Asia/Tbilisi : Tbilisi, Kutaisi, Batumi, Sokhumi, Zugdidi',
    abbrev: 'Asia/Tbilisi',
  },
  {
    name: 'GMT+4 Asia/Yerevan : Yerevan, Gyumri, Vanadzor, Vagharshapat, Hrazdan',
    abbrev: 'Asia/Yerevan',
  },
  {
    name: 'GMT+4 Europe/Astrakhan : Astrakhan, Akhtubinsk, Znamensk, Kharabali, Kamyzyak',
    abbrev: 'Europe/Astrakhan',
  },
  {
    name: 'GMT+4 Europe/Samara : Samara, Tol’yatti, Izhevsk, Syzran’, Novokuybyshevsk',
    abbrev: 'Europe/Samara',
  },
  {
    name: 'GMT+4 Europe/Saratov : Saratov, Balakovo, Engel’s, Balashov, Vol’sk',
    abbrev: 'Europe/Saratov',
  },
  {
    name: 'GMT+4 Europe/Ulyanovsk : Ulyanovsk, Dimitrovgrad, Inza, Barysh, Novoul’yanovsk',
    abbrev: 'Europe/Ulyanovsk',
  },
  {
    name: 'GMT+4 Europe/Volgograd : Volgograd, Volzhskiy, Kamyshin, Mikhaylovka, Uryupinsk',
    abbrev: 'Europe/Volgograd',
  },
  {
    name: 'GMT+4 Indian/Mahe : Victoria, Anse Boileau, Bel Ombre, Beau Vallon, Cascade',
    abbrev: 'Indian/Mahe',
  },
  {
    name:
      'GMT+4 Indian/Mauritius : Port Louis, Beau Bassin-Rose Hill, Vacoas, Curepipe, Quatre Bornes',
    abbrev: 'Indian/Mauritius',
  },
  {
    name: 'GMT+4 Indian/Reunion : Saint-Denis, Saint-Paul, Saint-Pierre, Le Tampon, Saint-André',
    abbrev: 'Indian/Reunion',
  },
  {
    name: 'GMT+4:30 Asia/Kabul : Kabul, Kandahār, Mazār-e Sharīf, Herāt, Jalālābād',
    abbrev: 'Asia/Kabul',
  },
  {
    name: 'GMT+5 Antarctica/Mawson ',
    abbrev: 'Antarctica/Mawson',
  },
  {
    name: 'GMT+5 Asia/Aqtau : Shevchenko, Zhanaozen, Beyneu, Shetpe, Yeraliyev',
    abbrev: 'Asia/Aqtau',
  },
  {
    name: 'GMT+5 Asia/Aqtobe : Aktobe, Kandyagash, Shalqar, Khromtau, Embi',
    abbrev: 'Asia/Aqtobe',
  },
  {
    name: 'GMT+5 Asia/Ashgabat : Ashgabat, Türkmenabat, Daşoguz, Mary, Balkanabat',
    abbrev: 'Asia/Ashgabat',
  },
  {
    name: 'GMT+5 Asia/Atyrau : Atyrau, Qulsary, Shalkar, Balykshi, Maqat',
    abbrev: 'Asia/Atyrau',
  },
  {
    name: 'GMT+5 Asia/Dushanbe : Dushanbe, Khujand, Kŭlob, Bokhtar, Istaravshan',
    abbrev: 'Asia/Dushanbe',
  },
  {
    name: 'GMT+5 Asia/Karachi : Karachi, Lahore, Faisalabad, Rawalpindi, Multan',
    abbrev: 'Asia/Karachi',
  },
  {
    name: 'GMT+5 Asia/Oral : Oral, Aqsay, Zhänibek, Tasqala, Zhumysker',
    abbrev: 'Asia/Oral',
  },
  {
    name: 'GMT+5 Asia/Qyzylorda : Kyzylorda, Baikonur, Novokazalinsk, Aral, Chiili',
    abbrev: 'Asia/Qyzylorda',
  },
  {
    name: 'GMT+5 Asia/Samarkand : Samarkand, Bukhara, Nukus, Qarshi, Jizzax',
    abbrev: 'Asia/Samarkand',
  },
  {
    name: 'GMT+5 Asia/Tashkent : Tashkent, Namangan, Andijon, Qo‘qon, Chirchiq',
    abbrev: 'Asia/Tashkent',
  },
  {
    name: 'GMT+5 Asia/Yekaterinburg : Yekaterinburg, Chelyabinsk, Ufa, Perm, Orenburg',
    abbrev: 'Asia/Yekaterinburg',
  },
  {
    name: 'GMT+5 Indian/Kerguelen : Port-aux-Français',
    abbrev: 'Indian/Kerguelen',
  },
  {
    name: 'GMT+5 Indian/Maldives : Male, Fuvahmulah, Hithadhoo, Kulhudhuffushi, Thinadhoo',
    abbrev: 'Indian/Maldives',
  },
  {
    name: 'GMT+5:30 Asia/Colombo : Colombo, Dehiwala-Mount Lavinia, Moratuwa, Jaffna, Negombo',
    abbrev: 'Asia/Colombo',
  },
  {
    name: 'GMT+5:30 Asia/Kolkata : Mumbai, Delhi, Bengaluru, Kolkāta, Chennai',
    abbrev: 'Asia/Kolkata',
  },
  {
    name: 'GMT+5:45 Asia/Kathmandu : Kathmandu, Pokhara, Pātan, Biratnagar, Birgañj',
    abbrev: 'Asia/Kathmandu',
  },
  {
    name: 'GMT+6 Antarctica/Vostok ',
    abbrev: 'Antarctica/Vostok',
  },
  {
    name: 'GMT+6 Asia/Almaty : Almaty, Karagandy, Shymkent, Taraz, Nur-Sultan',
    abbrev: 'Asia/Almaty',
  },
  {
    name: 'GMT+6 Asia/Bishkek : Bishkek, Osh, Jalal-Abad, Karakol, Tokmok',
    abbrev: 'Asia/Bishkek',
  },
  {
    name: 'GMT+6 Asia/Dhaka : Dhaka, Chittagong, Khulna, Rājshāhi, Comilla',
    abbrev: 'Asia/Dhaka',
  },
  {
    name: 'GMT+6 Asia/Omsk : Omsk, Tara, Kalachinsk, Znamenskoye, Tavricheskoye',
    abbrev: 'Asia/Omsk',
  },
  {
    name: 'GMT+6 Asia/Qostanay : Kostanay, Rudnyy, Dzhetygara, Arkalyk, Lisakovsk',
    abbrev: 'Asia/Qostanay',
  },
  {
    name: 'GMT+6 Asia/Thimphu : Thimphu, Punākha, Tsirang, Phuntsholing, Pemagatshel',
    abbrev: 'Asia/Thimphu',
  },
  {
    name: 'GMT+6 Asia/Urumqi : Zhongshan, Ürümqi, Zhanjiang, Shihezi, Huocheng',
    abbrev: 'Asia/Urumqi',
  },
  {
    name: 'GMT+6 Indian/Chagos ',
    abbrev: 'Indian/Chagos',
  },
  {
    name:
      'GMT+6:30 Asia/Yangon : Yangon, Mandalay, Nay Pyi Taw, Mawlamyine, Kyain Seikgyi Township',
    abbrev: 'Asia/Yangon',
  },
  {
    name: 'GMT+6:30 Indian/Cocos : West Island',
    abbrev: 'Indian/Cocos',
  },
  {
    name: 'GMT+7 Antarctica/Davis ',
    abbrev: 'Antarctica/Davis',
  },
  {
    name: 'GMT+7 Asia/Bangkok : Bangkok, Samut Prakan, Mueang Nonthaburi, Udon Thani, Chon Buri',
    abbrev: 'Asia/Bangkok',
  },
  {
    name: 'GMT+7 Asia/Barnaul : Barnaul, Biysk, Rubtsovsk, Novoaltaysk, Gorno-Altaysk',
    abbrev: 'Asia/Barnaul',
  },
  {
    name: 'GMT+7 Asia/Hovd : Khovd, Ölgii, Ulaangom, Uliastay, Altai',
    abbrev: 'Asia/Hovd',
  },
  {
    name: 'GMT+7 Asia/Ho_Chi_Minh : Ho Chi Minh City, Hanoi, Da Nang, Haiphong, Biên Hòa',
    abbrev: 'Asia/Ho_Chi_Minh',
  },
  {
    name: 'GMT+7 Asia/Jakarta : Jakarta, Surabaya, Medan, Bandung, Bekasi',
    abbrev: 'Asia/Jakarta',
  },
  {
    name: 'GMT+7 Asia/Krasnoyarsk : Krasnoyarsk, Abakan, Norilsk, Achinsk, Kyzyl',
    abbrev: 'Asia/Krasnoyarsk',
  },
  {
    name:
      'GMT+7 Asia/Novokuznetsk : Novokuznetsk, Kemerovo, Prokop’yevsk, Leninsk-Kuznetsky, Kiselëvsk',
    abbrev: 'Asia/Novokuznetsk',
  },
  {
    name: 'GMT+7 Asia/Novosibirsk : Novosibirsk, Berdsk, Iskitim, Akademgorodok, Kuybyshev',
    abbrev: 'Asia/Novosibirsk',
  },
  {
    name: 'GMT+7 Asia/Phnom_Penh : Phnom Penh, Takeo, Sihanoukville, Battambang, Siem Reap',
    abbrev: 'Asia/Phnom_Penh',
  },
  {
    name: 'GMT+7 Asia/Pontianak : Pontianak, Tanjung Pinang, Palangkaraya, Singkawang, Sampit',
    abbrev: 'Asia/Pontianak',
  },
  {
    name: 'GMT+7 Asia/Tomsk : Tomsk, Seversk, Strezhevoy, Kolpashevo, Asino',
    abbrev: 'Asia/Tomsk',
  },
  {
    name: 'GMT+7 Asia/Vientiane : Vientiane, Pakse, Thakhèk, Savannakhet, Luang Prabang',
    abbrev: 'Asia/Vientiane',
  },
  {
    name: 'GMT+7 Indian/Christmas : Flying Fish Cove',
    abbrev: 'Indian/Christmas',
  },
  {
    name: 'GMT+8 Antarctica/Casey ',
    abbrev: 'Antarctica/Casey',
  },
  {
    name: 'GMT+8 Asia/Brunei : Bandar Seri Begawan, Kuala Belait, Seria, Tutong, Bangar',
    abbrev: 'Asia/Brunei',
  },
  {
    name: 'GMT+8 Asia/Choibalsan : Baruun-Urt, Choibalsan',
    abbrev: 'Asia/Choibalsan',
  },
  {
    name: 'GMT+8 Asia/Hong_Kong : Hong Kong, Kowloon, Tsuen Wan, Yuen Long Kau Hui, Tung Chung',
    abbrev: 'Asia/Hong_Kong',
  },
  {
    name: 'GMT+8 Asia/Irkutsk : Irkutsk, Ulan-Ude, Bratsk, Angarsk, Ust’-Ilimsk',
    abbrev: 'Asia/Irkutsk',
  },
  {
    name:
      'GMT+8 Asia/Kuala_Lumpur : Kota Bharu, Kuala Lumpur, Klang, Kampung Baru Subang, Johor Bahru',
    abbrev: 'Asia/Kuala_Lumpur',
  },
  {
    name: 'GMT+8 Asia/Kuching : Kuching, Kota Kinabalu, Sandakan, Tawau, Miri',
    abbrev: 'Asia/Kuching',
  },
  {
    name: 'GMT+8 Asia/Macau : Macau',
    abbrev: 'Asia/Macau',
  },
  {
    name: 'GMT+8 Asia/Makassar : Makassar, Denpasar, City of Balikpapan, Banjarmasin, Manado',
    abbrev: 'Asia/Makassar',
  },
  {
    name: 'GMT+8 Asia/Manila : Quezon City, Manila, Caloocan City, Budta, Davao',
    abbrev: 'Asia/Manila',
  },
  {
    name: 'GMT+8 Asia/Shanghai : Shanghai, Beijing, Tianjin, Guangzhou, Shenzhen',
    abbrev: 'Asia/Shanghai',
  },
  {
    name: 'GMT+8 Asia/Singapore : Singapore, Woodlands',
    abbrev: 'Asia/Singapore',
  },
  {
    name: 'GMT+8 Asia/Taipei : Taipei, Kaohsiung, Taichung, Tainan, Banqiao',
    abbrev: 'Asia/Taipei',
  },
  {
    name: 'GMT+8 Asia/Ulaanbaatar : Ulan Bator, Erdenet, Darhan, Hovd, Murun-kuren',
    abbrev: 'Asia/Ulaanbaatar',
  },
  {
    name: 'GMT+8 Australia/Perth : Perth, Rockingham, Mandurah, Bunbury, Albany',
    abbrev: 'Australia/Perth',
  },
  {
    name: 'GMT+8:45 Australia/Eucla ',
    abbrev: 'Australia/Eucla',
  },
  {
    name: 'GMT+9 Asia/Chita : Chita, Krasnokamensk, Borzya, Petrovsk-Zabaykal’skiy, Aginskoye',
    abbrev: 'Asia/Chita',
  },
  {
    name: 'GMT+9 Asia/Dili : Dili, Maliana, Suai, Likisá, Aileu',
    abbrev: 'Asia/Dili',
  },
  {
    name: 'GMT+9 Asia/Jayapura : Ambon, Jayapura, Sorong, Ternate, Abepura',
    abbrev: 'Asia/Jayapura',
  },
  {
    name: 'GMT+9 Asia/Khandyga ',
    abbrev: 'Asia/Khandyga',
  },
  {
    name: 'GMT+9 Asia/Pyongyang : Pyongyang, Hamhŭng, Namp’o, Sunch’ŏn, Hŭngnam',
    abbrev: 'Asia/Pyongyang',
  },
  {
    name: 'GMT+9 Asia/Seoul : Seoul, Busan, Incheon, Daegu, Daejeon',
    abbrev: 'Asia/Seoul',
  },
  {
    name: 'GMT+9 Asia/Tokyo : Tokyo, Yokohama, Osaka, Nagoya, Sapporo',
    abbrev: 'Asia/Tokyo',
  },
  {
    name: 'GMT+9 Asia/Yakutsk : Yakutsk, Blagoveshchensk, Belogorsk, Neryungri, Svobodnyy',
    abbrev: 'Asia/Yakutsk',
  },
  {
    name: 'GMT+9 Pacific/Palau : Koror, Koror Town, Kloulklubed, Ulimang, Mengellang',
    abbrev: 'Pacific/Palau',
  },
  {
    name:
      'GMT+9:30 Australia/Adelaide : Adelaide, Adelaide Hills, Mount Gambier, Morphett Vale, Gawler',
    abbrev: 'Australia/Adelaide',
  },
  {
    name: 'GMT+9:30 Australia/Broken_Hill : Broken Hill',
    abbrev: 'Australia/Broken_Hill',
  },
  {
    name: 'GMT+9:30 Australia/Darwin : Darwin, Alice Springs, Palmerston, Howard Springs',
    abbrev: 'Australia/Darwin',
  },
  {
    name: 'GMT+10 Antarctica/DumontDUrville ',
    abbrev: 'Antarctica/DumontDUrville',
  },
  {
    name: 'GMT+10 Asia/Ust-Nera ',
    abbrev: 'Asia/Ust-Nera',
  },
  {
    name:
      'GMT+10 Asia/Vladivostok : Vladivostok, Khabarovsk, Khabarovsk Vtoroy, Komsomolsk-on-Amur, Ussuriysk',
    abbrev: 'Asia/Vladivostok',
  },
  {
    name: 'GMT+10 Australia/Brisbane : Brisbane, Gold Coast, Logan City, Townsville, Cairns',
    abbrev: 'Australia/Brisbane',
  },
  {
    name: 'GMT+10 Australia/Currie ',
    abbrev: 'Australia/Currie',
  },
  {
    name: 'GMT+10 Australia/Hobart : Hobart, Launceston, Burnie, Devonport, Sandy Bay',
    abbrev: 'Australia/Hobart',
  },
  {
    name: 'GMT+10 Australia/Lindeman ',
    abbrev: 'Australia/Lindeman',
  },
  {
    name:
      'GMT+10 Australia/Melbourne : Melbourne, Geelong, Bendigo, Ballarat, Melbourne City Centre',
    abbrev: 'Australia/Melbourne',
  },
  {
    name: 'GMT+10 Australia/Sydney : Sydney, Canberra, Newcastle, Wollongong, Maitland',
    abbrev: 'Australia/Sydney',
  },
  {
    name: 'GMT+10 Pacific/Chuuk : Weno, Colonia',
    abbrev: 'Pacific/Chuuk',
  },
  {
    name:
      'GMT+10 Pacific/Guam : Dededo Village, Yigo Village, Tamuning, Tamuning-Tumon-Harmon Village, Mangilao Village',
    abbrev: 'Pacific/Guam',
  },
  {
    name: 'GMT+10 Pacific/Port_Moresby : Port Moresby, Lae, Mount Hagen, Popondetta, Madang',
    abbrev: 'Pacific/Port_Moresby',
  },
  {
    name: 'GMT+10 Pacific/Saipan : Saipan, San Jose Village',
    abbrev: 'Pacific/Saipan',
  },
  {
    name: 'GMT+10:30 Australia/Lord_Howe ',
    abbrev: 'Australia/Lord_Howe',
  },
  {
    name: 'GMT+11 Antarctica/Macquarie ',
    abbrev: 'Antarctica/Macquarie',
  },
  {
    name: 'GMT+11 Asia/Magadan : Magadan, Ust-Nera, Susuman, Ola',
    abbrev: 'Asia/Magadan',
  },
  {
    name: 'GMT+11 Asia/Sakhalin : Yuzhno-Sakhalinsk, Korsakov, Kholmsk, Okha, Nevel’sk',
    abbrev: 'Asia/Sakhalin',
  },
  {
    name: 'GMT+11 Asia/Srednekolymsk ',
    abbrev: 'Asia/Srednekolymsk',
  },
  {
    name: 'GMT+11 Pacific/Bougainville : Arawa, Buka',
    abbrev: 'Pacific/Bougainville',
  },
  {
    name: 'GMT+11 Pacific/Efate : Port-Vila, Luganville, Isangel, Sola, Lakatoro',
    abbrev: 'Pacific/Efate',
  },
  {
    name: 'GMT+11 Pacific/Guadalcanal : Honiara, Malango, Auki, Gizo, Buala',
    abbrev: 'Pacific/Guadalcanal',
  },
  {
    name: 'GMT+11 Pacific/Kosrae : Tofol',
    abbrev: 'Pacific/Kosrae',
  },
  {
    name: 'GMT+11 Pacific/Norfolk : Kingston',
    abbrev: 'Pacific/Norfolk',
  },
  {
    name: 'GMT+11 Pacific/Noumea : Nouméa, Mont-Dore, Dumbéa, Païta, Wé',
    abbrev: 'Pacific/Noumea',
  },
  {
    name: 'GMT+11 Pacific/Pohnpei : Kolonia, Kolonia Town, Palikir - National Government Center',
    abbrev: 'Pacific/Pohnpei',
  },
  {
    name: 'GMT+12 Antarctica/McMurdo ',
    abbrev: 'Antarctica/McMurdo',
  },
  {
    name: 'GMT+12 Asia/Anadyr : Anadyr, Bilibino',
    abbrev: 'Asia/Anadyr',
  },
  {
    name:
      'GMT+12 Asia/Kamchatka : Petropavlovsk-Kamchatsky, Yelizovo, Vilyuchinsk, Klyuchi, Mil’kovo',
    abbrev: 'Asia/Kamchatka',
  },
  {
    name: 'GMT+12 Pacific/Auckland : Auckland, Wellington, Christchurch, Manukau City, North Shore',
    abbrev: 'Pacific/Auckland',
  },
  {
    name: 'GMT+12 Pacific/Fiji : Suva, Lautoka, Nadi, Labasa, Ba',
    abbrev: 'Pacific/Fiji',
  },
  {
    name:
      'GMT+12 Pacific/Funafuti : Funafuti, Savave Village, Tanrake Village, Toga Village, Asau Village',
    abbrev: 'Pacific/Funafuti',
  },
  {
    name: 'GMT+12 Pacific/Kwajalein : Ebaye, Jabat',
    abbrev: 'Pacific/Kwajalein',
  },
  {
    name: 'GMT+12 Pacific/Majuro : Majuro, Arno, Jabor, Wotje, Mili',
    abbrev: 'Pacific/Majuro',
  },
  {
    name: 'GMT+12 Pacific/Nauru : Yaren, Baiti, Anabar, Uaboe, Ijuw',
    abbrev: 'Pacific/Nauru',
  },
  {
    name: 'GMT+12 Pacific/Tarawa : Tarawa, Betio Village, Bikenibeu Village',
    abbrev: 'Pacific/Tarawa',
  },
  {
    name: 'GMT+12 Pacific/Wake ',
    abbrev: 'Pacific/Wake',
  },
  {
    name: 'GMT+12 Pacific/Wallis : Mata-Utu, Leava, Alo',
    abbrev: 'Pacific/Wallis',
  },
  {
    name: 'GMT+12:45 Pacific/Chatham : Waitangi',
    abbrev: 'Pacific/Chatham',
  },
  {
    name: 'GMT+13 Pacific/Apia : Apia, Asau, Mulifanua, Afega, Leulumoega',
    abbrev: 'Pacific/Apia',
  },
  {
    name: 'GMT+13 Pacific/Enderbury ',
    abbrev: 'Pacific/Enderbury',
  },
  {
    name: 'GMT+13 Pacific/Fakaofo : Atafu Village, Nukunonu, Fale old settlement',
    abbrev: 'Pacific/Fakaofo',
  },
  {
    name: 'GMT+13 Pacific/Tongatapu : Nuku‘alofa, Lapaha, Neiafu, Pangai, ‘Ohonua',
    abbrev: 'Pacific/Tongatapu',
  },
  {
    name: 'GMT+14 Pacific/Kiritimati ',
    abbrev: 'Pacific/Kiritimati',
  },
];
